module.exports = __webpack_public_path__ + "img/countdown.b1d42960.png";